import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCalendar, FiUsers, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BookingWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [bookingData, setBookingData] = useState({
    checkIn: '',
    checkOut: '',
    guests: 2
  });

  const handleChange = (e) => {
    setBookingData({
      ...bookingData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle booking submission
    console.log('Booking data:', bookingData);
    setIsOpen(false);
  };

  return (
    <>
      {/* Floating Booking Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(true)}
        className="fixed bottom-8 right-8 z-40 w-16 h-16 rounded-full bg-terracotta-earth text-white shadow-2xl flex items-center justify-center"
      >
        <SafeIcon icon={FiCalendar} className="w-6 h-6" />
      </motion.button>

      {/* Booking Widget Modal */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setIsOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              className="glass-card p-8 max-w-md w-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsOpen(false)}
                className="absolute top-4 right-4 text-white hover:text-terracotta-earth transition-colors"
              >
                <SafeIcon icon={FiX} className="w-6 h-6" />
              </button>

              <h3 className="text-2xl font-playfair font-bold text-white mb-6">
                Book Your Sanctuary
              </h3>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-white/80 font-lato text-sm mb-2">
                    Check-in Date
                  </label>
                  <input
                    type="date"
                    name="checkIn"
                    value={bookingData.checkIn}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:outline-none focus:border-terracotta-earth transition-colors"
                    required
                  />
                </div>

                <div>
                  <label className="block text-white/80 font-lato text-sm mb-2">
                    Check-out Date
                  </label>
                  <input
                    type="date"
                    name="checkOut"
                    value={bookingData.checkOut}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:outline-none focus:border-terracotta-earth transition-colors"
                    required
                  />
                </div>

                <div>
                  <label className="block text-white/80 font-lato text-sm mb-2">
                    Number of Guests
                  </label>
                  <select
                    name="guests"
                    value={bookingData.guests}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white focus:outline-none focus:border-terracotta-earth transition-colors"
                  >
                    <option value={1} className="bg-forest-green">1 Guest</option>
                    <option value={2} className="bg-forest-green">2 Guests</option>
                    <option value={3} className="bg-forest-green">3 Guests</option>
                    <option value={4} className="bg-forest-green">4 Guests</option>
                  </select>
                </div>

                <div className="text-center p-4 bg-white/10 rounded-lg">
                  <p className="text-white/80 font-lato text-sm mb-2">
                    Best Rate Guaranteed
                  </p>
                  <p className="text-terracotta-earth font-playfair font-semibold text-lg">
                    From $120 / night
                  </p>
                  <p className="text-white/60 font-lato text-xs mt-1">
                    Save 10% booking direct
                  </p>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="w-full glass-button-primary py-4 text-white font-lato font-medium text-lg"
                >
                  Check Availability
                </motion.button>
              </form>

              <p className="text-white/60 font-lato text-xs text-center mt-4">
                Free cancellation up to 48 hours before arrival
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default BookingWidget;